import { Component, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavParams, Platform } from '@ionic/angular';

import { DialogConstant, MessageConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { LogService } from '../../service/log.service';
import { DialogService } from '../../service/dialog.service';
import { ApiService } from '../../service/api.service';
import { EventService } from '../../service/event.service';

import { CreatedirModalPage } from '../createdir-modal/createdir-modal.page';

@Component({
    selector: 'app-cloudselector-modal',
    templateUrl: './cloudselector-modal.page.html',
    styleUrls: ['./cloudselector-modal.page.scss'],
})
export class CloudselectorModalPage
{
    private parent_id = "";
    private current_folder = "";
    private folder_stack = [];
    private folder_list = [];
    private childs = [];
    private is_reading = true;
    private select_file_cache_id = "-1";
    private is_backdrop = false;
    private is_mobile = false;

    private cloudselector_modal = null;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private modalCtrl: ModalController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private log: LogService,
        private dialog: DialogService,
        private api: ApiService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'cloudselector-modal', value: null});
        this.is_mobile = this.platform.is("mobile");
        await this.getFolderList();
    }

    async getFolderList()
    {
        const list = await this.api.getfilelist(this.parent_id);

        this.folder_list = [];

        list.map((v) => {
            if (v.file_flg == 0 && v.trash_flg == 0) {
                this.folder_list.push(v);
            }
        });

        this.is_reading = false;
    }

    async moveFolder(file_cache_id, name)
    {
        await this.setFolderStack(this.parent_id, this.current_folder);
        this.parent_id = String(file_cache_id);
        this.select_file_cache_id = "-1";
        this.changeDetectorRef.detectChanges();
        this.current_folder = name;

        await this.getFolderList();
    }

    async backFolder()
    {
        const ret = await this.popFolderStack();
        this.parent_id = ret.parent_id;
        this.current_folder = ret.name;
        this.select_file_cache_id = "-1";
        this.changeDetectorRef.detectChanges();
        await this.getFolderList();
    }

    popFolderStack()
    {
        if (this.folder_stack.length > 0) {
            return this.folder_stack.pop();
        }

        return { parent_id: "", name: "" };
    }

    setFolderStack(parent_id, name)
    {
        this.folder_stack.push({parent_id: parent_id, name: name});
    }

    async openModal()
    {
        if (!this.auth.empty(this.cloudselector_modal)) return;
        this.cloudselector_modal = 0;

        const css = (this.is_mobile ? ' createdir-modal-small' : '');

        this.cloudselector_modal = await this.modalCtrl.create({
            component: CreatedirModalPage,
            id: 'createdir-modal',
            cssClass: `createdir-modal${css}`,
            backdropDismiss: false,
            swipeToClose: true,
            mode: 'ios'
        });

        this.cloudselector_modal.onDidDismiss().then(async(ret) => {
            this.is_backdrop = false;

            if (ret !== null && !this.auth.empty(ret.data)) {
                const data = ret.data;
                const name = data['name'];
                if (await this.createFolder(name) === true) {
                    await this.getFolderList();
                }
            }

            this.cloudselector_modal = null;
        });

        this.is_backdrop = true;
        await this.cloudselector_modal.present();
    }

    async createFolder(name)
    {
        this.log.debug(`createFolder -> parent_id: `+this.parent_id+' / name: '+name);

        const resp = await this.api.createfolder(this.parent_id, name);

        if (!this.api.isSuccess(`createfolder:`+this.parent_id)) {
            let err_msg = this.api.getErrorMessage(`createfolder:`+this.parent_id);

            if (err_msg == 'file.create.parent_id.notfound') {
                err_msg = DialogConstant.UPLOAD_PARENT_ID_ERR;
            }

            this.dialog.message(DialogConstant.ERROR_TITLE, err_msg, DialogConstant.BUTTON_OK);

            return false;
        }

        return true;
    }

    async refresh(event)
    {
        await this.getFolderList();
        event.target.complete();
    }

    async selectFoldar(event)
    {
        const file_cache_id = event.target.value;

        this.auth.changeRadio(`cloudselector-radio`, file_cache_id);

        this.select_file_cache_id = file_cache_id;
    }

    async saveFoldar()
    {
        if (this.select_file_cache_id == "-1") {
            this.select_file_cache_id = this.parent_id;
        }

        this.event.modal_subject.next({key: "closeModal", id: 'cloudselector-modal', value: { parent_id: this.select_file_cache_id }});
    }

    cloudselectoreClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'cloudselector-modal', value: null});
    }
}
